import { UTCDate } from '@date-fns/utc'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'

export const DATE_FORMAT = 'dd/MM/yy'

export function formatDate(date?: string | Date, formatStr = DATE_FORMAT): string {
  if (!date) return ''
  return format(new UTCDate(date), formatStr, { locale: enUS })
}

export const getBlogFormattedDate = (
  publishedAt?: Date | string | null,
  modifiedAt?: Date | string | null,
  modifiedLabel?: string,
) => {
  if (modifiedAt) {
    const modifiedDateString = formatDate(modifiedAt, 'MMMM d, yyyy')

    if (!modifiedLabel) {
      return modifiedDateString
    }

    return `${modifiedLabel} ${modifiedDateString}`
  }

  if (publishedAt) {
    return formatDate(publishedAt, 'MMMM d, yyyy')
  }

  return ''
}
